const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin');
const smeLoan = () => import('./smeLoanEdit.vue');


//2022年中小企业首次贷款利息补贴资金申请表
export default {
  routes: [
    {
      path: '/smes/loan/v2023/indexApp',
      name: 'smes_loan_2023_index_app',
      component: indexApp,
      meta: {public: true}
    }, {
      path: '/smes/loan/v2023/indexAdmin',
      name: 'smes_loan_2023_index_admin',
      component: indexAdmin,
      meta: {public: true}
    }, {
      path: '/smes/loan/v2023/smeLoanEdit',
      name: 'smes_loan_2023_edit',
      component: smeLoan,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/loan/v2023/router.js